export default function BadgesSection() {
  const badges = [
    {
      title: 'Skill Badges',
      description: 'Quick wins that show progress.',
      icon: 'ri-award-line',
      gradient: 'from-[#304FFE] to-[#5B9FED]',
    },
    {
      title: 'Microcredentials',
      description: 'Mastery-level achievements.',
      icon: 'ri-medal-line',
      gradient: 'from-[#7C4DFF] to-[#B794F6]',
    },
    {
      title: 'Your Profile',
      description: 'A visual record of everything you\'ve earned.',
      icon: 'ri-user-star-line',
      gradient: 'from-[#FF6B9D] to-[#FFA726]',
    },
  ];

  return (
    <section className="py-28 px-6 lg:px-12 relative overflow-hidden">
      {/* Animated gradient background - same as Hero */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/[0.08] via-transparent to-[#7C4DFF]/[0.08]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      </div>

      {/* Floating decorative elements - same as Hero */}
      <div className="absolute top-1/4 right-[10%] w-64 h-64 bg-gradient-to-br from-[#304FFE]/20 to-[#7C4DFF]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-[15%] w-48 h-48 bg-gradient-to-br from-[#7C4DFF]/15 to-[#304FFE]/15 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F36] mb-6">
            Make your progress visible
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Every challenge you complete earns a badge. Collect multiple badges to unlock microcredentials — stronger signals of your effort, growth and readiness.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-3 border border-gray-100 shadow-lg relative overflow-hidden"
            >
              {/* Subtle background gradient */}
              <div className={`absolute inset-0 bg-gradient-to-br ${badge.gradient} opacity-[0.03] group-hover:opacity-[0.06] transition-opacity`}></div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className={`w-24 h-24 bg-gradient-to-br ${badge.gradient} rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 group-hover:rotate-3 transition-all shadow-xl`}>
                  <i className={`${badge.icon} text-5xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1A1F36] mb-4 text-center">{badge.title}</h3>
                <p className="text-base text-gray-600 leading-relaxed text-center">{badge.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
